import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import stockCard from "../../../containers/modules/mutation/stock-card";

export default function StockCardRoute(props) {
  const { authUser } = props;
  return (
          <Route
          path="/stock-card"
            index
            element={
              <AccessControl
                name={"Stock Card List"}
                auth={authUser}
                component={stockCard}
              />
            }
          />
  );
}
